import { Image } from 'expo-image';
import { StyleSheet, View } from 'react-native';

import { ActionSheet, Button, Text } from '@fhs/ui';

type Props = {
  modalText: string | undefined;
  onClose(): void;
};
const foundationImage = require('./foundation.webp');

export function FoundationInformationModal({ onClose, modalText }: Props) {
  const defaultModalText =
    'Your donations help provide lifesaving equipment and needed \
     resources to first responders and public safety organizations, \
     allowing them to be better prepared to save lives in the \
     communities they serve.';

  return (
    <ActionSheet isVisible onClose={onClose}>
      <View style={styles.container}>
        <View style={styles.imageContainer}>
          <Image source={foundationImage} alt="Foundation image" style={styles.image} />
        </View>
        <Text.Ui size="md" style={styles.text}>
          {modalText || defaultModalText}
        </Text.Ui>
        <Button
          type="solid"
          size="lg"
          onPress={onClose}
          outlineFocusedStyle={styles.blueFocusOutline}
        >
          <Button.Text>Back To Cart</Button.Text>
        </Button>
      </View>
    </ActionSheet>
  );
}

const styles = StyleSheet.create({
  image: {
    height: 216,
    minWidth: 216,
    maxWidth: 342,
    aspectRatio: 342 / 216,
  },
  imageContainer: {
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
  },
  container: {
    gap: 24,
    paddingTop: 32,
    padding: 24,
  },
  blueFocusOutline: {
    borderColor: 'rgba(0, 102, 204, 0.5)',
  },
});
